var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name === 'detailsDown')?_c('div',[_c('router-view')],1):_c('div',[(_vm.titleIsShow)?_c('Title'):_vm._e(),_c('router-view'),(_vm.titleIsShow)?_c('RightZX'):_vm._e(),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }